import React from 'react';
import Seo from '../../components/utils/Seo';
import BodyAdminPage from './body/BodyAdminPage'
import Footer from '../../components/marketing/footer/Footer';
import NavBar from '../../components/marketing/navbar/NavBar';


function Admin(props) {
    return (
        <div className="selection:bg-primary selection:text-white">
            <Seo
                title="Interface d'administration rita nsangou"
                description="Rita traduis des documents, sites web et autres en anglais, français et espagnol discutons pour votre problème de traduction"
            />
            <NavBar classe="fixed top-0 w-full z-20 bg-white pb-2" />
            <BodyAdminPage />
            <Footer />
        </div>
    );
}

export default Admin;